import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  ZappiAbTestConfigResponse,
  ZappiAbTestSavePayload,
  ZappiAbTestUploadResponse,
} from './zappi-ab-testing.interface';

@Injectable({
  providedIn: 'root',
})
export class ZappiAbTestingService {
  private readonly _baseUrl = environment.pureSpectrum.url;

  constructor(private _http: HttpClient) {}

  getConfig(): Observable<ZappiAbTestConfigResponse> {
    return this._http.get<ZappiAbTestConfigResponse>(
      `${this._baseUrl}/operator-settings/zappi-ab-testing`
    );
  }

  uploadCsv(formData: FormData): Observable<ZappiAbTestUploadResponse> {
    return this._http.post<ZappiAbTestUploadResponse>(
      `${this._baseUrl}/operator-settings/zappi-ab-testing/upload`,
      formData
    );
  }

  save(payload: ZappiAbTestSavePayload): Observable<ZappiAbTestConfigResponse> {
    return this._http.put<ZappiAbTestConfigResponse>(
      `${this._baseUrl}/operator-settings/zappi-ab-testing`,
      payload
    );
  }
}
